import { HandlerProps, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { GetAlsoPurchasedProductCollectionApiV2Parameter, GetProductCollectionApiV2Parameter, GetRelatedProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

import {
    chain,
    DispatchCompleteLoadProducts,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";

replaceInChain(chain, DispatchCompleteLoadProducts, props => {
        const state = props.getState() as unknown as CustomApplicationState;
        const location = getLocation(state);
        const categoryPath = getSelectedCategoryPath(state) ||
            (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
        const catalogPageState = getCatalogPageStateByPath(state, categoryPath);
        const category = getCategoryState(state, catalogPageState.value?.categoryIdWithBrandId ?? catalogPageState.value?.categoryId).value;

        const { onSuccess, onError, isLoadMore, ...parameter } = props.parameter;
        props.apiParameter = parameter;
    
        if (props.parameter.isLoadMore) {
            const prevApiParams: typeof props.apiParameter = { ...props.apiParameter };
            prevApiParams.page =
                props.apiParameter.page && props.apiParameter.page > 1 ? props.apiParameter.page - 1 : undefined;
            const prevProducts = getProductsDataView(props.getState(), prevApiParams).value;

            if (prevProducts && props.apiResult.products )  {
                props.apiResult.products =  [...prevProducts, ...props.apiResult.products];
            }
            if (!prevProducts && props.parameter.page && props.parameter.page > 1) {
                props.apiParameter.page = props.parameter.page;
                props.apiParameter.pageSize = props.parameter.pageSize;
            }
        }
        if(category?.properties?.indexImage || category?.properties?.indexImage2){
            addPromoImageOnPLP(props, category);        
        }
    
        props.dispatch({
            type: "Data/Products/CompleteLoadProducts",
            collection: props.apiResult,
            parameter: props.apiParameter,
        });
    
 
});
function createPromoImageData(
    index: number,
    promoImagePath: string,
    promoImageURL: string 
): ProductModel {
    return {
        uri: promoImageURL,
        allowZeroPricing: true,
        brand: null,
        canAddToCart: false,
        canAddToWishlist: false,
        canConfigure: false,
        canonicalUrl: promoImageURL,
        canShowPrice: false,
        canShowUnitOfMeasure: false,
        configurationType: "None",
        customerProductNumber: "",
        customerUnitOfMeasure: "",
        id: `Temp-${index}`,
        imageAltText: "",
        isDiscontinued: false,
        isSponsored: false,
        isVariantParent: false,
        largeImagePath: promoImagePath,
        manufacturerItem: "",
        mediumImagePath: promoImagePath,
        minimumOrderQty: 0,
        packDescription: "",
        priceFacet: null,
        productLine: null,
        productNumber: "",
        productTitle: "",
        quoteRequired: false,
        defaultChildProductId: null,
        score: 0,
        smallImagePath: promoImagePath,
        trackInventory: false,
        unitListPrice: 0,
        unitListPriceDisplay: "",
        unitOfMeasures: null,
        urlSegment: promoImageURL,
        variantTypeId: null,
        salePriceLabel: "",
        cantBuy: true,
        properties: {},
        displayUrl: promoImageURL
    };
}

function addPromoImageOnPLP(
    props: HandlerProps<
        (GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter | GetAlsoPurchasedProductCollectionApiV2Parameter) &
            HasOnSuccess<ProductModel[]> &
            HasOnError<string>,
        {
            apiParameter:
                | GetProductCollectionApiV2Parameter
                | GetRelatedProductCollectionApiV2Parameter
                | GetAlsoPurchasedProductCollectionApiV2Parameter;
            apiResult: ProductCollectionModel;
        }
    >,
    category: Category | undefined
) {
    if (!props.apiResult.products || !category?.properties || !props.apiResult.pagination) {
        return;
    }

    props.apiResult.products = props.apiResult.products.filter(p => !p?.id?.startsWith("Temp-"));
    const products = props.apiResult.products;

    const firstImageIndex = category.properties.indexImage ? parseInt(category.properties.indexImage, 10) : NaN;
    const secondImageIndex = category.properties.indexImage2 ? parseInt(category.properties.indexImage2, 10) : NaN;

    const isValidIndex = (n: number) => Number.isFinite(n) && n >= 0;

    const getInsertIndex = (imageIndex: number) => {
        if (!isValidIndex(imageIndex)) {
            return -1;
        }
        return imageIndex;
    };

    if (category.properties.indexImage && products.length > 0) {
        const insertAt = getInsertIndex(firstImageIndex);
        if (insertAt >= 0) {
            const safeIndex = Math.min(insertAt, products.length);
            const promoImageData1 = createPromoImageData(
                safeIndex,
                category.properties.promoImage,
                category.properties.promoImgURL,
            );
            products.splice(safeIndex, 0, promoImageData1);
        }
    }

    if (category.properties.indexImage2 && products.length > 0) {
        let insertAt = getInsertIndex(secondImageIndex);

        if (insertAt >= 0) {
            const safeIndex = Math.min(insertAt, products.length);
            const promoImageData2 = createPromoImageData(
                safeIndex,
                category.properties.promoImage2,
                category.properties.promoImgURL2,
            );
            products.splice(safeIndex, 0, promoImageData2);
        }
    }
}






